import TwoStepSecurityPanel from './TwoStepSecurityPanel';

export default TwoStepSecurityPanel;
